import * as Icons from "@nova/component-icons"
import { NovaSpinner } from "@nova/component-nova-spinner"
import { HTMLAttributes, MouseEvent, type JSX } from "react"
import { useLoadingText } from "../../../useLoadingText"
import classNames from "classnames"

export const WorkspaceHomeCTAAlt = ({
    Icon,
    title,
    onClick,
    isLoading,
    disabled,
    loadingText,
    ...rest
}: {
    Icon: JSX.Element
    title: string
    onClick: (e: MouseEvent) => void
    isLoading?: boolean
    disabled?: boolean
    loadingText?: string
} & HTMLAttributes<HTMLDivElement>) => {
    loadingText = useLoadingText(!!isLoading, loadingText)
    return (
        <div
            {...rest}
            className={classNames(
                "relative flex-1 px-6 py-4 flex items-center gap-4 border shadow-create-menu rounded-lg transition-colors duration-150 group select-none",
                {
                    "border-white-400 bg-white-200 cursor-pointer": !isLoading, // Normal
                    "hover:bg-transparent": !isLoading, // Hover
                    "active:bg-transparent active:border-lazeryellow": !isLoading, // Active
                    "border-blue-500": isLoading, // Loading
                },
                rest.className
            )}
            onClick={!disabled ? onClick : undefined}
        >
            {Icon}

            <h4 className="text-gray-50 group-hover:text-gray-0 transition-colors duration-150 flex-grow">
                {isLoading && !!loadingText ? loadingText : title}
            </h4>

            {isLoading ? (
                <NovaSpinner width={24} height={24} />
            ) : (
                <Icons.Icon
                    Icon={Icons.ArrowRight}
                    className="text-lazeryellow opacity-0 transition-opacity duration-150 group-hover:opacity-100"
                />
            )}
        </div>
    )
}
